import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { FranchiseValues } from "src/models/Franchise.model";
import { handleValidNumber } from "src/utils/validations/numberInput";

type Props = {
  formikProps: FormikProps<FranchiseValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
};

const FranchiseForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "ADD" ? "Add Franchise" : "Update Franchise"}{" "}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            name="name"
            required
            value={values.name}
            onChange={(e) => {
              setFieldValue("name", e.target.value);
            }}
            label="Name"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="mobile"
            value={values.mobile}
            required
            onChange={(e) => {
              handleValidNumber(e) && setFieldValue("mobile", e.target.value);
            }}
            label="Mobile Number"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="location"
            value={values.location}
            required
            onChange={(e) => {
              setFieldValue("location", e.target.value);
            }}
            label="Location"
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default FranchiseForm;
